<ng-container *ngrxLet="dnsResponseInfo$ as dnsResponseInfo">
    <div class="log-cinematic-sub-section-dns-response__column-group">
        <!-- 1st column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ globalL10nKeys.responseCodeLabel | vtranslate }}
            </div>
            <span
                logFilter
                property="dns_response.response_code"
                [value]="responseCode"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.response_code as responseCode; else na"
            >
                {{ responseCode | enumValueLabel : 'DnsRcode' }}
            </span>

            <div logFieldTitle>{{ l10nKeys.recordSourceLabel | vtranslate }}</div>
            <span
                *ngIf="(connectionLog$ | async).dns_etype as dnsEtype; else na"
                logFilter
                property="dns_etype"
                [value]="dnsEtype"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ dnsEtype | enumValueLabel : 'DnsEntryType' }}
            </span>

            <div logFieldTitle>
                {{ l10nKeys.operationCodeLabel | vtranslate }}
            </div>
            <span
                logFilter
                property="dns_response.opcode"
                [value]="opCode"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.opcode as opCode; else na"
            >
                {{ opCode | enumValueLabel : 'DnsOpcode' }}
            </span>

            <div logFieldTitle>{{ l10nKeys.truncatedLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.truncation"
                [value]="dnsResponseInfo.truncation"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.truncation !== undefined; else na"
            >
                {{ dnsResponseInfo.truncation }}
            </span>
        </div>

        <!-- 2nd column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.questionCountLabel | vtranslate }}
            </div>
            <span
                logFilter
                property="dns_response.question_count"
                [value]="dnsResponseInfo.question_count"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.question_count !== undefined; else na"
            >
                {{ dnsResponseInfo.question_count }}
            </span>

            <div logFieldTitle>{{ l10nKeys.answerRecordCountLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.answer_records_count"
                [value]="dnsResponseInfo.answer_records_count"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.answer_records_count !== undefined; else na"
            >
                {{ dnsResponseInfo.answer_records_count }}
            </span>

            <div logFieldTitle>{{ l10nKeys.nameServerRecordCountLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.nameserver_records_count"
                [value]="dnsResponseInfo.nameserver_records_count"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.nameserver_records_count !== undefined; else na"
            >
                {{ dnsResponseInfo.nameserver_records_count }}
            </span>

            <div logFieldTitle>{{ l10nKeys.additionalRecordCountLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.additional_records_count"
                [value]="dnsResponseInfo.additional_records_count"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.additional_records_count !== undefined; else na"
            >
                {{ dnsResponseInfo.additional_records_count }}
            </span>
        </div>

        <!-- 3rd column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.authoritativeLabel | vtranslate }}
            </div>
            <span
                logFilter
                property="dns_response.authoritative_answer"
                [value]="dnsResponseInfo.authoritative_answer"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.authoritative_answer !== undefined else na"
            >
                {{ dnsResponseInfo.authoritative_answer }}
            </span>

            <div logFieldTitle>{{ l10nKeys.recursionAvailableLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.recursion_available"
                [value]="dnsResponseInfo.recursion_available"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.recursion_available !== undefined; else na"
            >
                {{ dnsResponseInfo.recursion_available }}
            </span>

            <div logFieldTitle>{{ l10nKeys.recursionDesiredLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.recursion_desired"
                [value]="dnsResponseInfo.recursion_desired"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.recursion_desired !== undefined; else na"
            >
                {{ dnsResponseInfo.recursion_desired }}
            </span>

            <div logFieldTitle>{{ l10nKeys.wildcardLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.is_wildcard"
                [value]="dnsResponseInfo.is_wildcard"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.is_wildcard !== undefined; else na"
            >
                {{ dnsResponseInfo.is_wildcard }}
            </span>

            <div logFieldTitle>{{ l10nKeys.fallbackAlgorithmUsedLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.fallback_algorithm_used"
                [value]="dnsResponseInfo.fallback_algorithm_used"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="dnsResponseInfo.fallback_algorithm_used !== undefined; else na"
            >
                {{ dnsResponseInfo.fallback_algorithm_used }}
            </span>
        </div>
    </div>

    <!-- DNS Opt Record -->
    <log-cinematic-dns-opt-record
        *ngIf="dnsResponseInfo.opt_record as optRecord"
        [dnsOptRecord]="optRecord"
        [dnsMessageType]="dnsMessageType"
    ></log-cinematic-dns-opt-record>

    <!-- Resource Records grid -->
    <ng-container *ngIf="dnsResponseInfo.records as records">
        <h6>{{ l10nKeys.resourceRecordsLabel | vtranslate:records.length }}</h6>
        <avi-data-grid
            [config]="resourceRecordsGridConfig"
            [rows]="records"
        ></avi-data-grid>
    </ng-container>
</ng-container>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>

<ng-template
    #domainNameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        logFilter
        property="dns_response.records.name"
        [value]="name"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
        *ngIf="row.name as name; else na"
    >
        {{ name }}
    </span>
</ng-template>

<ng-template
    #dnsRecordTypeFieldTemplateRef
    let-row
    let-index="index"
>
    <span *ngIf="row.type as type; else na">{{ type | enumValueLabel : 'DnsRecordType' }}</span>
</ng-template>

<ng-template
    #resolvedVirtualServiceNameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        logFilter
        property="dns_response.records.vs_name"
        [value]="name"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
        *ngIf="row.vs_name as name; else na"
    >
        {{ name }}
    </span>
</ng-template>

<ng-template
    #expandedContentTemplateRef
    let-row
>
    <div class="log-cinematic-sub-section-dns-response__grid-expanded-content">
        <!-- left column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.memberLocationLabel | vtranslate }}
            </div>
            <ng-container *ngIf="row.location?.name as location; else na">
                <div
                    logNationalFlag
                    [countryCode]="location"
                ></div>
                <span
                    logFilter
                    property="dns_response.records.location.name"
                    [value]="location"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ location | countryCodeToName }}
                </span>
            </ng-container>

            <div logFieldTitle>{{ l10nKeys.ttlLabel | vtranslate }}</div>
            <span
                *ngIf="row.ttl !== undefined; else na"
                logFilterList
                property="dns_response.records.ttl"
                [value]="row.ttl"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ row.ttl }}
            </span>

            <div logFieldTitle>{{ l10nKeys.nsNameLabel | vtranslate }}</div>
            <span
                *ngIf="row.nsname as nsName; else na"
                logFilter
                property="dns_response.records.nsname"
                [value]="nsName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ nsName }}
            </span>

            <div logFieldTitle>{{ globalL10nKeys.ipAddressLabel | vtranslate }}</div>
            <span
                *ngIf="(row.addr6_ip_str || row.addr_ip) as ip; else na"
                logFilter
                property="dns_response.records.{{ row.addr6_ip_str ? 'addr6_ip_str' : 'addr_ip' }}"
                [value]="ip"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ip }}
            </span>

            <div logFieldTitle>{{ l10nKeys.cnameLabel | vtranslate }}</div>
            <span
                *ngIf="row.cname as cName; else na"
                logFilter
                property="dns_response.records.cname"
                [value]="cName"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ cName }}
            </span>
        </div>

        <!-- right column -->
        <div
            logCinematicSectionColumn
            [expandTwoColumns]="true"
        >
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.mailServerLabel | vtranslate }}
            </div>
            <span
                logFilter
                property="dns_response.records.mail_server"
                [value]="mailServer"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="row.mail_server as mailServer; else na"
            >
                {{ mailServer }}
            </span>

            <div logFieldTitle>{{ globalL10nKeys.portLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.records.port"
                [value]="row.port"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="row.port !== undefined; else na"
            >
                {{ row.port }}
            </span>

            <div logFieldTitle>{{ globalL10nKeys.priorityLabel | vtranslate }}</div>
            <span
                logFilterList
                property="dns_response.records.priority"
                [value]="row.priority"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="row.priority !== undefined; else na"
            >
                {{ row.priority }}
            </span>

            <div logFieldTitle>{{ l10nKeys.textResourceDataLabel | vtranslate }}</div>
            <span
                logFilter
                property="dns_response.records.text_rdata"
                [value]="trData"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
                *ngIf="row.text_rdata as trData; else na"
            >
                {{ trData }}
            </span>
        </div>
    </div>
</ng-template>
